import React from 'react';
import { Route, Redirect } from 'react-router-dom';
// import { UserProvider, UserContext } from '../context/context';

export const PrivateRoute = ({ component: Component, ...rest }) => (

    <Route {...rest} render={props => (
        localStorage.getItem('user')
            ? <Component {...props} />
            : <Redirect to={{ pathname: '/', state: { from: props.location } }} />
    )} />
)